export const SCHEDU_SEARCH_SENSOR_CONFIG_STATUS = {
  id: 8,
  text: 'public.config_status',
  type: 'select',
  paramsName: 'configurate',
  isChooze: false,
  selectParam: [
    {
      value: 0,
      label: 'device.wait_config'
    },
    {
      value: 1,
      label: 'device.configuring'
    },
    {
      value: 2,
      label: 'device.configured'
    }
  ]
}

export const SCHEDU_SEARCH_CONFIG_STATUS = {
  id: 8,
  text: 'public.config_status',
  type: 'select',
  paramsName: 'configStatus',
  isChooze: false,
  selectParam: [
    {
      value: 0,
      label: 'device.wait_config'
    },
    {
      value: 1,
      label: 'device.configuring'
    },
    {
      value: 2,
      label: 'device.configured'
    }
  ]
}
